import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from 'omni-common-ui';
import styles from './style.postcss';

const FeedbackTipsDialog = ({ isOpen, onOKClick, children }) => (
  <Dialog
    isOpen={isOpen}
    className={styles.FeedbackTipsDialog_card}
    onRequestClose={() => onOKClick()}
  >
    <div className={styles.FeedbackTipsDialog}>
      <div className={styles.FeedbackTipsDialog_body}>{children}</div>
      <Button.Container
        align="center"
        className={styles.FeedbackTipsDialog_buttonWrapper}
      >
        <Button
          type={Button.Type.primary}
          className={styles.FeedbackTipsDialog_button}
          onClick={() => onOKClick()}
        >
          Got It
        </Button>
      </Button.Container>
    </div>
  </Dialog>
);

FeedbackTipsDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOKClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default FeedbackTipsDialog;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/FeedbackTipsDialog/index.jsx